import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn, RaikoGridTwoColumn,
    RaikoSectionContainer, showErrorMessage, showServerErrorMessage, showSuccessMessage, showWarningMessage,
} from "@moeindal/base-raiko-panel-components";
import {Alert, AlertTitle} from "@mui/lab";
import {css} from "@emotion/css";
import React, {useState} from "react";
import {FormControl} from "@mui/material";
import RaikoMaterialOutlinedPasswordInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedPasswordInput";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {UserService} from "../../serverService/userService/UserService";
import {useAuthState} from "../../context/AuthContext";
import {useParams} from "react-router-dom";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function ChangeUserPassword() {


    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new UserService()
    const {fundID} = useAuthState()
    const {id: userID} = useParams()


    const [newPassword, setNewPassword] = useState("");
    const [repeatNewPassword, setRepeatNewPassword] = useState("")

    function handleUpdatePassword() {
        if (checkInput()) {
            loading.show()
            service.updateUserPassword(fundID, userID, newPassword)
                .then(response => {
                    showSuccessMessage("رمز عبور با موفقیت بروزرسانی شد.")
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }

    }

    function checkInput() {
        let message = ""
        let state = false

        if (newPassword < 8) {
            message = "رمز عبور جدید حداقل باید 8 کاراکتر باشد!"
        } else if (repeatNewPassword !== newPassword) {
            message = "تکرار رمز عبور با رمز عبور جدید مطابقت ندارد!"
        } else
            state = true
        if (message.length > 0)
            showWarningMessage(message)
        return state

    }

    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoSectionContainer
                    title={"ویرایش رمز عبور"}
                    hasActionButton
                    actionButtonOnclick={handleUpdatePassword}
                >
                    <Alert severity="warning">
                        <AlertTitle>لطفا نکات زیر را مورد توجه قرار دهید:</AlertTitle>
                        <div className={css`display: flex;
                          flex-direction: column;
                          gap: 8px;
                        `}>
                            <span>رمز عبور حداقل باید <strong> 8 کاراکتر</strong> باشد.</span>
                            <span>برای داشتن رمزی قوی تر از <strong>حروف بزرگ و کوچک، کاراکتر ها و اعداد</strong> با یکدیگر استفاده نمایید.</span>
                        </div>
                    </Alert>
                    <RaikoGridTwoColumn>
                        <FormControl fullWidth>
                            <RaikoMaterialOutlinedPasswordInput
                                labelText={"رمز عبور جدید"}
                                spellCheck={false}
                                value={newPassword}
                                onChange={e => {
                                    setNewPassword(e.target.value)
                                }}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <RaikoMaterialOutlinedPasswordInput
                                labelText={"تکرار رمز عبور جدید"}
                                spellCheck={false}
                                value={repeatNewPassword}
                                onChange={e => {
                                    setRepeatNewPassword(e.target.value)
                                }}
                            />
                        </FormControl>
                    </RaikoGridTwoColumn>
                </RaikoSectionContainer>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}